import $ from 'jquery'
import { consentCheck } from './consent-handler'

/**
 * Configuration
 */
var trackingConfig = {
  baseUrl: 'grenke.de',
  socialTracking: [
    'facebook',
    'twitter',
    'youtube',
    'plus.google',
    'linkedin',
    'xing',
    'kununu'
  ],
  fileTracking: [
    '.pdf',
    '.jpg',
    '.png',
    '.doc',
    '.ppt',
    '.xls'
  ],
  xboundTracking: [
    'sample.com',
    'asd.de'
  ]
}

function init (url) {
  if (url || url != null || url.indexOf('.') > -1) {
    trackingConfig.baseUrl = url
  }
  setLinkEvents()
  setFormEvents()
  setEloquaEvents()
  setSearchEvents()
}

/**
 *  Iterate all links and add tracking events (<a>)
 */
function setLinkEvents () {
  $('.body-wrapper a').each(function () {
    var currLink = this,
      $currLink = $(currLink),
      eventSettings = getLinkSettings($currLink)

    if ($(currLink).parents('nav').hasClass('navigation-main') || $(currLink).parents('div').hasClass('flyout-container')) {
      // cont. and do nothing
    } else if ($currLink.hasClass('btn-primary') || $currLink.hasClass('btn-secondary') || $currLink.hasClass('btn-tertiary')) {
      const currButton = this
      const $currButton = $(currButton)
      const eventSettings = getTypedButtonSettings($currButton)

      if (eventSettings && eventSettings.valid) {
        currButton.addEventListener('click', function () {
          sendEvent(eventSettings.type, eventSettings.category, eventSettings.label, eventSettings.value)
        })
      }
    } else {
      if (eventSettings && eventSettings.valid) {
        // console.log("register event with settings: type'" + eventSettings.type + "', category'" + eventSettings.category + "', label'" + eventSettings.label + "'");
        currLink.addEventListener('click', function () {
          sendEvent(eventSettings.type, eventSettings.category, eventSettings.label)
        })
      } else {
        // console.log("link is not valid: type'" + eventSettings.type + "', category'" + eventSettings.category + "', label'" + eventSettings.label + "'");
        // console.log("$currLink: ", $currLink);
        // console.log("------");
      }
    }
  })
}

/**
 *  register Eloqua Event Catcher (gets Event Data from Eloqua Form [contact-detail.js]
 *  on successfull form submission) and redirects data to Piwik
 */
function setEloquaEvents () {
  document.addEventListener('eloqua-form-sent', (e) => {
    const eventSettings = buildEventSettings('form', 'submit', e.detail)
    sendEvent(eventSettings.type, eventSettings.category, eventSettings.label)
  })
}

/**
 *  register Website Search Events. Search Clicks and "Enter" Input is managed by Form data (no js), so
 *  we have to catch the event here. Clicks on search suggestions are managed in header.js and fire a
 *  website-search which we catch here, so both types are covered.
 */
function setSearchEvents () {
  const element = document.querySelector('form[name="search"]') || null

  if (!element) {
    return
  }

  element.addEventListener('submit', function (e) {
    const queryInput = this.querySelector('input[name="query"]')
    const searchQuery = queryInput ? queryInput.value : ''

    const referrer = window.location.href || 'none'
    sendEvent('search', searchQuery, referrer)
  })

  document.addEventListener('website-search', (e) => {
    sendEvent('search', e.detail.query, e.detail.referrer)
  })
}

/**
 *  Iterate all form inputs and add tracking events (<input>, <select>, <textarea>)
 */
function setFormEvents () {
  $('.body-wrapper form').each(function () {
    var form = this,
      $form = $(form)

    $form.find('input, textarea').each(function () {
      var type = $(this).attr('type'),
        eventLabel = this.name

      if (eventLabel) {
        if (type == 'checkbox') {
          this.addEventListener('change', function () {
            sendEvent('form', 'edit', eventLabel)
          })
        } else if (type == 'file') {
          this.addEventListener('change', function () {
            sendEvent('upload', 'buttonclick', eventLabel)
          })
        } else {
          this.addEventListener('change', function () {
            sendEvent('form', 'edit', eventLabel)
          })

          this.addEventListener('focus', function () {
            sendEvent('form', 'focus', eventLabel)
          })
        }
      }
    })

    $form.find('select').each(function () {
      var eventLabel = this.value

      if (eventLabel) {
        this.addEventListener('change', function () {
          sendEvent('form', 'select', eventLabel)
        })
      }
    })

    $form.find('.formRow--dropdown-list-item').each(function () {
      var eventLabel = $(this).attr('data-dropdown-value')

      if (eventLabel) {
        this.addEventListener('click', function () {
          sendEvent('form', 'select', eventLabel)
        })
      }
    })

  })
}

function getTypedButtonSettings ($currButton) {
  const buttonText = $currButton.find('.use-hyphens').text().trim()
  return buildButtonEventSettings($currButton, buttonText)
}

/**
 * Helper function to get button settings from jquery object
 * @param $currButton
 */
function getButtonSettings ($currButton) {
  var eventSettings = {},
    buttonText = $currButton.find('.use-hyphens').text().trim()

  if ($currButton.hasClass('js-sticky-phone')) {
    eventSettings = buildEventSettings('module', 'sticky', 'tel')
  } else if ($currButton.hasClass('js-sticky-phone-close')) {
    eventSettings = buildEventSettings('module', 'sticky', 'tel-close')
  } else if ($currButton.hasClass('back-to-top')) {
    eventSettings = buildEventSettings('module', 'back-to-top', 'click')
  } else if ($currButton.hasClass('slider-arrow')) {
    if ($currButton.hasClass('next')) {
      eventSettings = buildEventSettings('module', 'slider', 'next')
    } else if ($currButton.hasClass('prev')) {
      eventSettings = buildEventSettings('module', 'slider', 'prev')
    }
  } else if ($currButton.hasClass('dot')) {
    var dotIndicator = $currButton.attr('data-slider-indicator')

    eventSettings = buildEventSettings('module', 'slider', dotIndicator ? 'dot-' + dotIndicator : 'dot')
  } else {
    eventSettings = buildEventSettings('button', buttonText, window.location.href)
  }

  return eventSettings
}

function buildButtonEventSettings ($button, label) {
  const targetUrl = $button.attr('href') || ''
  let buttonType = 0

  if ($button.hasClass('btn-primary')) {
    buttonType = 1
  } else if ($button.hasClass('btn-secondary')) {
    buttonType = 2
  } else if ($button.hasClass('btn-tertiary')) {
    buttonType = 3
  }
  return buildEventSettings('button', label, targetUrl, buttonType)
}

/**
 * Helper function to get link settings from jquery object
 * @param $currLink
 */
function getLinkSettings ($currLink) {
  var linkTarget = $currLink.attr('href'),
    eventSettings = {}

  if (linkTarget !== undefined) {
    // Social links
    trackingConfig.socialTracking.some(function (val) {
      if (linkTarget.indexOf(val) != -1) {
        eventSettings = buildEventSettings('outbound', 'social', linkTarget)
        return true // stop loop
      }
    })

    // Mailto links
    if (!eventSettings.valid) {
      if (linkTarget.indexOf('mailto:') != -1) {
        eventSettings = buildEventSettings('contact', 'mailto', linkTarget)
      }
    }

    // Tel links
    if (!eventSettings.valid) {
      if (linkTarget.indexOf('tel:') != -1) {
        eventSettings = buildEventSettings('contact', 'tel', linkTarget)
      }
    }

    // File links
    if (!eventSettings.valid) {
      trackingConfig.fileTracking.some(function (val) {
        if (linkTarget.indexOf(val) != -1) {
          eventSettings = buildEventSettings('download', val, linkTarget)
          return true // stop loop
        }
      })
    }

    // File via getfile
    if (!eventSettings.valid) {
      if (linkTarget.indexOf('download') != -1) {
        eventSettings = buildEventSettings('download', 'Brandmaster', linkTarget)
      }
    }

    // Xbound links
    if (!eventSettings.valid) {
      trackingConfig.xboundTracking.some(function (val) {
        if (linkTarget.indexOf(val) != -1) {
          eventSettings = buildEventSettings('outbound', 'xbound', linkTarget)
          return true // stop loop
        }
      })
    }

    // Deep links
    if (!eventSettings.valid) {
      if (linkTarget.substring(0, 1) == '#') {
        eventSettings = buildEventSettings('deeplink', 'click', linkTarget)
      }
    }

    // External links
    if (!eventSettings.valid) {
      if (((linkTarget.substring(0, 8) == 'https://') || (linkTarget.substring(0, 7) == 'http://') || (linkTarget.substring(0, 4) == 'www.')) && linkTarget.indexOf(trackingConfig.baseUrl) <= -1) {
        eventSettings = buildEventSettings('outbound', 'other', linkTarget)
      }
    }

    // Internal links
    if (!eventSettings.valid) {
      var linkText = ''

      if ($currLink.hasClass('btn') || $currLink.hasClass('teaser-box-item')) {
        linkText = $currLink.find('.use-hyphens').text().trim()
      } else {
        linkText = $currLink.text().trim()
      }

      if ($currLink.hasClass('btn-primary') || $currLink.hasClass('btn-secondary') || $currLink.hasClass('btn-tertiary')) {
        eventSettings = buildButtonEventSettings($currLink, linkText)
      } else if ($currLink.hasClass('js-sticky-mail')) {
        eventSettings = buildEventSettings('module', 'sticky', 'mail')
      } else {
        eventSettings = buildEventSettings('link', linkText, linkTarget)
      }
    }
  } else if (!linkTarget && $currLink.attr('id') == 'search-btn') {
    eventSettings = buildEventSettings('primary button', 'Jetzt suchen', 'locationfinder')
  } else if (!linkTarget && $currLink.parents('div').hasClass('swiper-slide')) {
    eventSettings = buildEventSettings('module', $currLink.html(), 'slider')
  }

  return eventSettings
}

/**
 * Helper function to build link settings
 * @param type
 * @param category
 * @param label
 * @param value (optional)
 */
function buildEventSettings (type, category, label, value = 0) {
  var eventSettings = {}

  eventSettings.type = type
  eventSettings.category = category
  eventSettings.label = label
  eventSettings.value = value

  if (eventSettings.type && eventSettings.category && eventSettings.label) {
    eventSettings.valid = true
  }

  return eventSettings
}

/**
 * Send tracking event
 * @param category
 * @param action
 * @param name
 * @param value (optional)
 */
function sendEvent (category, action, name, value) {
  // Group C0002: Marketing
  // returns null if there is no OneTrust on the page.
  let consent = consentCheck('C0002')

  // OneTrust is not set or consent for this group is true
  if (consent === null || consent) {
    if (window.hasOwnProperty('_paq') && category && action && name) {
      if (typeof value === 'number') {
        // console.log("send _paq.push: event='trackEvent', eventCategory='" + category + "', eventAction='" + action + "', eventName='" + name + "'" + "', eventValue='" + value + "'");
        _paq.push(['trackEvent', category, action, name, value])
      } else {
        // console.log("send _paq.push: event='trackEvent', eventCategory='" + category + "', eventAction='" + action + "', eventName='" + name + "'");
        _paq.push(['trackEvent', category, action, name])
      }
    }
  }
}

export default {
  init
}
